import _ from 'underscore'
import Backbone from 'backbone'
import MenuViewTemplate from '../templates/menu.tpl'
import HeaderView from './header'
import NavView from './nav'
import config from '../config'
import user from '../user'

const MenuView = Backbone.View.extend({
    el: '#current-view',
    events: {
        'click .tab': 'onTabClick'
    },
    initialize() {
        this.template = _.template(MenuViewTemplate)

        // Save the full apps list for filtering later
        this.apps = config.get('apps')

        // Listen for purchase events so we can update the menu icons when an app is purchased or removed
        this.listenTo(user.get('purchased'), 'add remove reset', this.updatePurchaseStatus)
        this.listenTo(user, 'change', this.updatePurchaseStatus)
    },
    render() {
        this.$el.html(this.template())

        // Append the header and nav views
        const headerView = new HeaderView()
        this.$('#header-view').append(headerView.render().el)

        const navView = new NavView()
        this.$('#nav-view').append(navView.render().el)

        // Determine which tab was active the last time (or default to 'all')
        const activeTab = config.get('activeTab') || 'all'
        this.filterApps(activeTab)

        // Append version info
        this.$('#app-menu-footer').append(`Version: ${APP_VERSION}`)

        return this
    },

    // Helper to render a given list of apps
    renderApps(apps) {
        const $menuView = this.$('#app-menu-view')
        $menuView.empty()
        apps.forEach((app) => {
            // Check if the app is purchased using the purchase collection
            const isPurchased = user.get('purchased').purchased(app.id)

            // Use the regular icon if purchased or if the app is free
            let icon = isPurchased ? `${app.slug}.webp` : `${app.slug}-lite.webp`

            const listItem = `
                <li class="menu-item">
                    <a href="#app/${app.slug}">
                        <img src="data/icons/${icon}" alt="${app.name}" />
                    </a>
                </li>`
            $menuView.append(listItem)
        })
    },

    // Called when purchase events occur – re-render the app icons
    updatePurchaseStatus() {
        this.renderApps(this.apps)
    },

    // Unified method to filter apps and update active tab state
    filterApps(filter) {
        // Set active class on selected tab
        this.$('.tab').removeClass('active')
        this.$(`.tab[data-filter="${filter}"]`).addClass('active')

        // Filter apps using the filter map
        const filterMap = {
            ks2: app => app.tag === 'ks2',
            fs: app => app.tag === 'fs',
            ks3_gcse: app => app.tag === 'ks3' || app.tag === 'ks4'
        }

        // Filter the apps based on the selected filter
        const filteredApps = filter === 'all'
            ? this.apps
            : this.apps.filter(filterMap[filter])

        // Render filtered apps
        this.renderApps(filteredApps)
    },

    // Handle tab clicks to filter the app list
    onTabClick(e) {
        e.preventDefault()
        const $tab = this.$(e.currentTarget)
        const filter = $tab.data('filter')

        // Save the active tab in config so that it can be remembered next time
        config.set('activeTab', filter)

        // Delegate filtering to our unified method
        this.filterApps(filter)
    }
})

export default MenuView
